import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { nextPartyDate, pad } from "@/lib/party";

export default function Countdown() {
  const [ms, setMs] = useState(() => nextPartyDate() - new Date());

  useEffect(() => {
    const id = setInterval(() => setMs(nextPartyDate() - new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const clamp = Math.max(0, ms);
  const d = Math.floor(clamp / 86400000);
  const h = Math.floor(clamp / 3600000) % 24;
  const m = Math.floor(clamp / 60000) % 60;
  const s = Math.floor(clamp / 1000) % 60;

  const cells = [
    [pad(d), "Giorni", "countdown-days"],
    [pad(h), "Ore", "countdown-hours"],
    [pad(m), "Min", "countdown-mins"],
    [pad(s), "Sec", "countdown-secs"],
  ];

  return (
    <div className="countdown-section">
      <div className="countdown-title">Mancano al party</div>
      <div className="countdown-grid">
        {cells.map(([value, label, testId]) => (
          <div className="countdown-item" key={label}>
            <div className="countdown-val" data-testid={testId}>
              <motion.span
                key={value}
                initial={{ y: 9, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.35, ease: "easeOut" }}
              >
                {value}
              </motion.span>
            </div>
            <div className="countdown-lbl">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
